// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100vw;
  display: block;
  z-index: 1000;
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.ui-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 0;
  z-index: 1000;
  background-color: transparent;
  touch-action: none;
}

.innerBar {
  position: relative;
  margin: 0 0 0 auto;
  height: 12vw;
  width: 72vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 1001;
  padding: 0;
  border-radius: 50px;
  touch-action: none;
  backdrop-filter: blur(8px) saturate(120%) contrast(1.3);
  -webkit-backdrop-filter: blur(8px) saturate(120%) contrast(1.3);
  background: rgba(255, 255, 255, 0.28);
  border: 0px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 24px -12px rgb(255, 255, 255);
}
.innerBar::before, .innerBar::after {
  content: "";
  position: absolute;
  border-radius: 50px;
  pointer-events: none;
}
.innerBar::before {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  background-size: 200% 200%;
  background-position: 0% 100%;
}
.innerBar::after {
  top: 0;
  left: 0;
  width: 0px;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3));
}

.ui-cutout {
  position: absolute;
  top: 0;
  left: 0vw;
  width: 24vw;
  height: 12vw;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  touch-action: none;
  transition: all 0.3s ease-in-out;
}
.ui-cutout.hideCut {
  opacity: 0;
}
.ui-cutout.showCut {
  opacity: 1;
}

.indicatorTab {
  width: 22vw;
  height: 10vw;
  margin: 1vw;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  opacity: 0.8;
  z-index: 500;
  transition: all 0.3s ease-in-out;
  touch-action: none;
  backdrop-filter: blur(5px) saturate(120%) contrast(1.3);
  -webkit-backdrop-filter: blur(5px) saturate(120%) contrast(1.3);
  box-shadow: var(--shadow-glass-anim-end);
}
.indicatorTab::before {
  content: "";
  position: absolute;
  height: 100%;
  left: 50%;
  top: 50%;
  width: 100%;
  border: 2px solid var(--ion-color-secondary);
  opacity: 1;
  filter: blur(5px);
  pointer-events: none;
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
}

.cutoutTransition {
  background: linear-gradient(40deg, hsl(var(--drop-color-primary)/0.9) 0%, hsl(var(--drop-shadeDark-primary)/0.8) 25%, hsl(var(--drop-color-primary)/0.7) 30%, hsl(var(--drop-shadeDark-primary)/0.8) 70%, hsl(var(--drop-color-primary)/0.8) 75%, hsl(var(--drop-color-primary)/0.9) 100%);
  background-size: 300% 300%;
  background-position: 0 0;
  background-repeat: no-repeat;
}

.menuCut {
  background-position: 50% 20%;
}

.orderCut {
  background-position: 100% 40%;
}

.calendarCut {
  background-position: 0% 0%;
}

.iconF {
  width: 6vw;
  height: 6vw;
  transition: all 0.3s ease-in-out;
}

.selectedIcon {
  color: var(--ion-text-primary);
  fill: var(--ion-text-primary);
  stroke: var(--ion-text-primary);
}

.unSelectedIcon {
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
}

.ui-label {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  height: 8vw;
  width: 24vw;
  z-index: 2;
  position: relative;
  background: transparent;
  padding: 1vh 0;
  transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
}
.ui-label ion-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6vw;
  height: 6vw;
  transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
}

.selected {
  pointer-events: none !important;
}
.selected ion-icon {
  width: 6vw;
  height: 6vw;
  filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));
}

.hideBar {
  opacity: 0;
  transition: all 0.3s ease-in-out;
}

.showBar {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}

.topMacros {
  max-width: 80vw;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tab-bar/tab-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EAEA,uDAAA;EACA,+DAAA;EACA,qCAAA;EACA,0CAAA;EACA,mKACE;AADJ;AAME;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AALJ;AAQE;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;EACA,4BAAA;AANJ;AASE;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oGAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;AARF;AAUE;EACE,UAAA;AARJ;AAWE;EACE,UAAA;AATJ;;AAYA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACF,YAAA;EACE,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,uDAAA;EACA,+DAAA;EACA,wCAAA;AATF;AAWE;EACE,WAAA;EACA,kBAAA;EACF,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACE,4CAAA;EACF,UAAA;EACE,iBAAA;EAOA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAfJ;;AAmBA;EAEE,0RAAA;EAEA,0BAAA;EACA,wBAAA;EACA,4BAAA;AAlBF;;AAuBA;EACE,4BAAA;AApBF;;AAuBA;EACE,6BAAA;AApBF;;AAuBA;EACE,0BAAA;AApBF;;AAiDA;EAKE,UAAA;EACA,WAAA;EAEA,gCAAA;AAnDF;;AAqDA;EACI,8BAAA;EACF,6BAAA;EACA,+BAAA;AAlDF;;AAoDA;EACE,+BAAA;EACA,8BAAA;EACA,gCAAA;AAjDF;;AAsDA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iDAAA;AAnDF;AAqDE;EAIE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,iDAAA;AAtDJ;;AA2DA;EACE,+BAAA;AAxDF;AA0DE;EAIE,UAAA;EACA,WAAA;EACA,yDAAA;AA3DJ;;AAgEA;EACE,UAAA;EACA,gCAAA;AA7DF;;AAiEA;EACE,UAAA;EACA,gCAAA;AA9DF;;AAkEA;EACE,eAAA;EACA,SAAA;AA/DF","sourcesContent":[":host {\n  width: 100vw;\n  display: block;\n  z-index: 1000;\n  overflow: hidden;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  touch-action: none;\n  user-select: none;\n}\n\n.ui-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 0;\n  z-index: 1000;\n  background-color: transparent;\n  touch-action: none;\n}\n\n.innerBar {\n  position: relative;\n  margin: 0 0 0 auto;\n  height: 12vw;\n  width: 72vw;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  z-index: 1001;\n  padding: 0;\n  border-radius: 50px;\n  touch-action: none;\n\n  backdrop-filter: blur(8px) saturate(120%) contrast(1.3);\n  -webkit-backdrop-filter: blur(8px) saturate(120%) contrast(1.3);\n  background: rgba(255, 255, 255, 0.28);\n  border: 0px solid rgba(255, 255, 255, 0.3);\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 0 24px -12px rgba(255, 255, 255, 1.2);\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    border-radius: 50px;\n    pointer-events: none;\n  }\n\n  &::before {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);\n    background-size: 200% 200%;\n    background-position: 0% 100%;\n  }\n\n  &::after {\n    top: 0;\n    left: 0;\n    width: 0px;\n    height: 100%;\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3));\n  }\n}\n\n.ui-cutout {\n  position: absolute;\n  top: 0;\n  left: 0vw;\n  width: 24vw;\n  height: 12vw;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  touch-action: none;\n  transition: all 0.3s ease-in-out;\n\n  &.hideCut {\n    opacity: 0;\n  }\n\n  &.showCut {\n    opacity: 1;\n  }\n}\n.indicatorTab {\n  width: 22vw;\n  height: 10vw;\n  margin: 1vw;\n  border-radius: 50px;\n  position: relative;\n  overflow: hidden;\nopacity: 0.8;\n  z-index: 500;\n  transition: all 0.3s ease-in-out;\n  touch-action: none;\n  backdrop-filter: blur(5px) saturate(120%) contrast(1.3);\n  -webkit-backdrop-filter: blur(5px) saturate(120%) contrast(1.3);\n  box-shadow: var(--shadow-glass-anim-end);\n\n  &::before {\n    content: '';\n    position: absolute;\n  height: 100%;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n    border: 2px solid var(--ion-color-secondary);\n  opacity: 1;\n    filter: blur(5px);\n    // background: linear-gradient(-20deg,\n    //     hsl(var(--drop-color-primary)/0.05) 0%,\n    //     hsl(var(--drop-black-primary)/0.1) 50%,\n    //     hsl(var(--drop-color-primary)/0.05) 100%);\n    // background-size: 200% 200%;\n    // background-position: 0% 100%;\n    pointer-events: none;\n    border-radius: 50px;\n    transition: all 0.3s ease-in-out;\n    // transform: translateX(-50%) translateY(-50%) rotate(0deg) scale(1);\n  }\n}\n.cutoutTransition {\n\n  background: linear-gradient(40deg,hsl(var(--drop-color-primary)/0.9) 0%, hsl(var(--drop-shadeDark-primary)/0.8) 25%, hsl(var(--drop-color-primary)/0.7) 30%,hsl(var(--drop-shadeDark-primary)/0.8) 70%, hsl(var(--drop-color-primary)/0.8) 75%, hsl(var(--drop-color-primary)/0.9) 100%);\n  // transition: all 1s ease-in-out;\n  background-size: 300% 300%;\n  background-position: 0 0;\n  background-repeat: no-repeat;\n\n\n}\n\n.menuCut{\n  background-position: 50% 20%;\n}\n\n.orderCut {\n  background-position: 100% 40%;\n}\n\n.calendarCut {\n  background-position: 0% 0%;\n}\n\n// .menuCut::before{\n//     // -moz-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -ms-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -webkit-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   transform: translateX(-50%) translateY(-50%) rotate(-45deg) scale(1.25);\n//     height: 300%;\n//   opacity: 1;\n// }\n\n// .orderCut::before {\n//   // -moz-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -ms-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -webkit-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   transform: translateX(-50%) translateY(-50%) rotate(-45deg) scale(1.25);\n//     height: 300%;\n//   opacity: 1;\n// }\n\n// .calendarCut::before {\n//   // -moz-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -ms-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   // -webkit-transform: translateX(-50%) translateY(-50%) rotate(-25deg);\n//   transform: translateX(-50%) translateY(-50%) rotate(-45deg) scale(1.25);\n//     height: 300%;\n//   opacity: 1;\n// }\n.iconF {\n\n  // color: var(--iconColor);\n  // fill: var(--iconColor);\n  // stroke: var(--iconColor);\n  width: 6vw;\n  height: 6vw;\n  // filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));\n  transition: all 0.3s ease-in-out;\n}\n.selectedIcon{\n    color: var(--ion-text-primary);\n  fill: var(--ion-text-primary);\n  stroke: var(--ion-text-primary);\n}\n.unSelectedIcon{\n  color: var(--ion-color-primary);\n  fill: var(--ion-color-primary);\n  stroke: var(--ion-color-primary);\n}\n\n\n\n.ui-label {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  pointer-events: auto;\n  height: 8vw;\n  width: 24vw;\n  z-index: 2;\n  position: relative;\n  background: transparent;\n  padding: 1vh 0;\n  transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);\n\n  ion-icon {\n    // color: var(--ion-color-primary);\n    // fill: var(--ion-color-primary);\n    // stroke: var(--ion-color-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 6vw;\n    height: 6vw;\n    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);\n  }\n}\n\n\n.selected {\n  pointer-events: none !important;\n\n  ion-icon {\n    // color: var(--ion-text-primary);\n    // fill: var(--ion-text-primary);\n    // stroke: var(--ion-text-primary);\n    width: 6vw;\n    height: 6vw;\n    filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));\n  }\n}\n\n\n.hideBar {\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n\n}\n\n.showBar {\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n\n}\n\n.topMacros {\n  max-width: 80vw;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
